import { Pagination } from '@mui/material';
import axios from 'axios';
import { useEffect, useRef, useState } from 'react';
import { CiEdit } from "react-icons/ci";
import { MdDeleteOutline } from "react-icons/md";
import { BiHide, BiShow } from "react-icons/bi";
import { toast } from 'react-toastify';
import { BACKEND_SERVER_URL } from '../../../http/http-config';
import SearchBox from '../Common-Components/SearchBox';
import '../common-css/Table.css';
import { deleteItem, showTableResponse } from '../common-helpers/commonServices';
import CUET_PricingsModal from './CUET_PricingModal';

const CUET_TestPricings = () => {
    const childRef = useRef();
    const [sections, setSections] = useState([]);
    // const [courses, setCourses] = useState([]);
    const [selectedCourse, setSelectedCourse] = useState("All Subject Types");
    const [currentPage, setCurrentPage] = useState(1);
    const [checked, setChecked] = useState(sections);
    const [loadSubjects, setSubjectLoading] = useState(false);
    console.log(selectedCourse)

    //set Table data
    useEffect(() => {
        axios.get(BACKEND_SERVER_URL + '/cuet/test-prices').then((res) => {
            let sections = res.data.data;
            console.log(sections);
            setSections(sections);
            setChecked(sections);
        }).catch((error) => {
            console.log(error)
            toast.error(error.response.data.message)
        })

    }, [loadSubjects])
    const pageSize = 100;
    const lastIndex = currentPage * pageSize;
    const firstIndex = lastIndex - pageSize;
    const records = checked?.slice(firstIndex, lastIndex);
    const npage = Math.ceil(checked?.length / pageSize)
    const number = [...Array(npage + 1).keys()].slice(1)

    const toggleHide = (id, currentHide) => {
        const hideStatus = (currentHide === 1 || currentHide === true) ? 0 : 1;
        axios.post(`${BACKEND_SERVER_URL}/cuet/togglePlanHide/${id}`, { hideStatus }).then((res) => {
            toast.success(res.data.message);
            setSubjectLoading(!loadSubjects);
        }).catch((error) => {
            toast.error(error.response.data.message);
        });
    };


    return (
        <>
            <div className="row">
                <div className="col-xl-12">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className=" page-title p-2 mb-2">{/*  flex-wrap  */}
                                <div className="row w-100 d-flex justify-content-between">
                                    <div className=' col-sm-8 d-flex justify-content-between'>
                                        <div className="col-2">
                                            <button type="button" className=" btn btn-dark btn-sm "
                                                onClick={() => childRef.current.openModal()}
                                            >
                                                + Add
                                            </button>
                                        </div>


                                    </div>
                                    <div className=" col-sm-4 input-group search-area mb-md-0 mb-3">
                                        <SearchBox setChecked={setChecked} dataArray={sections} searchingProperty={'Section'} />
                                    </div>
                                </div>

                            </div>

                        </div>
                        <div className="col-xl-12 wow fadeInUp" data-wow-delay="1.5s">
                            <div className="d-sm-flex text-center justify-content-between align-items-center">

                                <div className='dataTables_info text-dark'>
                                    Records: {checked.length}
                                </div>
                                {checked.length > pageSize ? <div className="dataTables_paginate paging_simple_numbers justify-content-center  mb-0 pt-2"
                                    id="example-student_wrapper">
                                    <Pagination count={number.length} variant="outlined" color='primary' size="small" page={currentPage} siblingCount={1} boundaryCount={2} onChange={(e, p) => setCurrentPage(parseInt(p))} />
                                </div> : null}
                            </div>
                            <div className="table-responsive full-data" style={{ paddingBottom: "1px", transform: 'rotateX(180deg)' }}>
                                <div id="example-student_wrapper" className="dataTables_wrapper no-footer">
                                    <table className="table-responsive-lg table display dataTablesCard student-tab 
                                    dataTable no-footer mt-0 mb-0" style={{ transform: 'rotateX(180deg)' }} id="example-student" >
                                        <thead style={{ backgroundColor: "#cccccc" }} >
                                            <tr className='text-center  border border-left'>
                                                <th className=' custom-table-header p-2' style={{ width: "80px" }}>Sl.No.</th>
                                                <th className=' custom-table-header p-2 text-start ps-4' style={{ width: "250px" }}>EXAM TYPE</th>
                                                <th className=' custom-table-header p-2 text-start ps-4' style={{ width: "200px" }}>SUBJECTS</th>
                                                <th className=' custom-table-header p-2 text-center' style={{ width: "100px" }}>TESTS</th>
                                                <th className=' custom-table-header p-2 text-center' style={{ width: "120px" }}>PRICE</th>
                                                <th className=' custom-table-header p-2 text-center' style={{ width: "120px" }}>DISCOUNT</th>
                                                <th className=' custom-table-header p-2 text-center' style={{ width: "150px" }}>ACTION</th>
                                                {/* <th className=' custom-table-header p-2  ps-3'>EXAM TYPE</th> */}

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {records.length > 0 ? records.map((item, ind) => (
                                                <tr key={ind} className={`${ind % 2 == 1 ? 'custom' : ''} row-height ${(item.Hide === 1 || item.hide === 1 || item.Hide === true || item.hide === true) ? 'hidden-plan-row' : ''}`} >
                                                    <td className='p-1 text-center' style={{ border: "1px solid #cccccc", width: "80px" }}>
                                                        <h6 className="mb-0 fw-bold">
                                                            {ind + 1 + firstIndex}
                                                        </h6>
                                                    </td>

                                                    <td className='p-1' style={{ border: "1px solid #cccccc", width: "250px" }}>
                                                        <div className="d-flex justify-content-between ">
                                                            <h6 className='mb-0 ps-4' style={{ fontSize: '13px', fontWeight: 'bold' }}>
                                                                {item.ExamType === "Section-IA" ? "Language Subjects" : item.ExamType === "Section-II" ? "Domain-Specific Subjects" : item.ExamType === "Section-III" ? "General Aptitude Test" : item.ExamType}
                                                            </h6>
                                                        </div>
                                                    </td>
                                                    <td className='p-1' style={{ border: "1px solid #cccccc", width: "200px" }}>
                                                        <div className="d-flex justify-content-between ">
                                                            <h6 className='mb-0 ps-4' style={{ fontSize: '13px', fontWeight: 'bold' }}>{item.SubjectType || 'All Subjects'}
                                                            </h6>
                                                        </div>
                                                    </td>

                                                    <td className='p-1 text-center' style={{ border: "1px solid #cccccc", width: "100px" }}>
                                                        <h6 className="mb-0 ">
                                                            {item.TestCount}
                                                        </h6>
                                                    </td>
                                                    <td className='p-1 text-center' style={{ border: "1px solid #cccccc", width: "120px" }}>
                                                        <h6 className="mb-0 ">
                                                            {item.Price}₹
                                                        </h6>
                                                    </td>
                                                    <td className='p-1 text-center' style={{ border: "1px solid #cccccc", width: "120px" }}>
                                                        <h6 className="mb-0 ">
                                                            {item.Discount}%
                                                        </h6>
                                                    </td>
                                                    <td className='p-1 text-center' style={{ border: "1px solid #cccccc", width: "150px" }}>
                                                        <div className="d-flex justify-content-center">
                                                            <CiEdit cursor='pointer' title='Edit' size={25} className='me-2 text-primary'
                                                                onClick={() => childRef.current.openModal(item)} />
                                                            {(item.Hide === 1 || item.hide === 1 || item.Hide === true || item.hide === true) ? (
                                                                <BiHide onClick={() => toggleHide(item.Sn, (item.Hide || item.hide))} cursor='pointer' title='Hide' size={25} className='me-2 text-warning' />
                                                            ) : (
                                                                <BiShow onClick={() => toggleHide(item.Sn, (item.Hide || item.hide))} cursor='pointer' title='Show' size={25} className='me-2 text-success' />
                                                            )}
                                                            <MdDeleteOutline onClick={() => deleteItem(item.Sn, 'Plan', '/cuet/deletePlan/', setSubjectLoading, loadSubjects)} color="red" title='Delete' cursor='pointer' size={25} />
                                                        </div>
                                                    </td>
                                                </tr>
                                            )) :
                                                <tr>
                                                    <td colSpan="9" className="text-center">
                                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px' }}>
                                                            {
                                                                showTableResponse(sections, checked)
                                                            }
                                                        </div>
                                                    </td>
                                                </tr>}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <CUET_PricingsModal ref={childRef} loadSubjects={loadSubjects} setSubjectLoading={setSubjectLoading} />
        </>
    )
}

export default CUET_TestPricings;
